import React, { Fragment, useRef } from 'react'
import { Container, Row } from 'reactstrap'
import ErrorBoundary from '../../ErrorBoundry'
import { Typography } from '@mui/material'
import { Icon } from '@progress/kendo-react-common'
import { Btn } from '../../AbstractElements'
import AssignSupervisorTable from './Components/AssignSupervisorTable'
// import AssignPocTable from './Components/AssignPocTable'

const AssignSupervisor = () => {
    const modalRef = useRef();
  return (
    <ErrorBoundary>
      {" "}
      <Fragment>
        <Container fluid={true}>
          <Row className="bg-primary rounded py-2 mb-2 d-flex justify-content-between">
            <div className="d-flex justify-content-between">
            <Typography variant="h5">
              <Icon
                style={{ fontSize: "25px", margin: "10px" }}
                name="file-data"
              />
              Assign Supervisor
            </Typography>
            {/* <Btn
              attrBtn={{
                color: "primary",
                onClick: () => {
                    if (modalRef.current) {
                        modalRef.current.openModal();
                        modalRef.current.newAddition();
                      }
                },
                className: "custom-back-button",
                // title: "Assign",
                style: {
                  fontSize: "18px",
                  outline: "1px solid white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "4px 8px",
                  paddingRight: "10px",
                  // fontSize: '1rem',
                  cursor: "pointer",
                  marginRight: "6px",
                },
              }}
            >
              Assign
            </Btn> */}
            </div>
          </Row>
          <AssignSupervisorTable ref={modalRef}/>
        </Container>
      </Fragment>
    </ErrorBoundary>
  );
}

export default AssignSupervisor
